import Slide from './Slide'

export const BasicSlide = ({
  showLogo,
  leftContent,
  title,
  description,
  comment,
  ...props
}) => {
  return (
    <Slide
      name='basic-slide'
      rightColSize={12}
      rightColSizeLg={7}
      leftColSize={12}
      leftColSizeLg={5}
      leftContent={
        <>
          <div className='left-content-container'>
            <img
              style={{ display: showLogo ? 'block' : 'none' }}
              className='main-logo ml-ss mb-3'
              alt='nonsense'
              src='/imgs/aragon-logo.png'
            />
            <div className='left-content'>
              <h2 className='fw-bold'>{title}</h2>
              <div className='left-description'>
                <p dangerouslySetInnerHTML={{ __html: description }}></p>
              </div>
              {comment && <div className='left-comment'>{comment}</div>}
              {leftContent}
            </div>
          </div>
          <div className='our-logo'>
            <a
              href="https://www.catapultlabs.xyz/?utm_source=onboarding&utm_medium=logo&utm_campaign=Index&utm_id=Indexcoop"
              target='_blank'
              rel='noreferrer'
            >
            <img
              className={`our-logo-img d-none d-lg-block d-inline-block`}
              alt='nonsense'
              src='/imgs/our-logo.png'
            />
            </a>
          </div>
        </>
      }
      {...props}
    />
  )
}
export default BasicSlide
